import { Component } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { BetslipOverAskPickBetBuilderBaseComponent } from '../../betslip-over-ask-pick-bet-builder-base.component';

@Component({
    selector: 'bs-betslip-over-aks-pick-bet-builder',
    templateUrl: './betslip-over-ask-pick-bet-builder.component.html',
    styleUrls: ['./betslip-over-ask-pick-bet-builder.component.scss'],
    standalone: false,
})
export class BetslipOverAskPickBetBuilderComponent extends BetslipOverAskPickBetBuilderBaseComponent {
    legsText: string;
    constructor(siteCore: Sitecore) {
        super(siteCore);
        this.messages = {
            betBuilderMarketName: siteCore.globalMessages.BetBuilderMarketText,
        };
        this.legsText = siteCore.betslip.overask.OverAskBetBuilderLegs;
    }
}
